const ActionType = {
    HANDLE_LOADING: 'HANDLE_LOADING',
    STORE_CONTACT_ID: 'STORE_CONTACT_ID',
    STORE_CONTACT_INFO: 'STORE_CONTACT_INFO',
    HANDLE_TAB: 'HANDLE_TAB',
    HANDLE_FROM: 'HANDLE_FROM',
    STORE_TOTAL_CAMPAIGN: 'STORE_TOTAL_CAMPAIGN',
    STORE_DEAL_CALLBACK: 'STORE_DEAL_CALLBACK',
}
export default ActionType;